import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Images } from 'assets/images';
import { aboutSectionInfo, buttons } from './data';
import { ROUTES } from 'utils/routeNames';
import {
  ContentContainer,
  AboutWrapper,
  AboutfirstItemWrapper,
  DiscoverWrapper,
  SectionTitle,
  Button,
  AboutSectionSubTitle,
  AboutSectionReadMoreButtonContainer,
  ReadMoreButton,
  ReadMoreButtonIcon,
  SecondSection,
  SecondSectionInfo,
  DiscoverBackSecondImage,
  DiscoweImg,
  ButtonConainer,
  TravelIcon,
} from './styled';

export const PopularPlacesSection = ({ about }) => {
  const [section, setSection] = useState('about');

  const navigate = useNavigate();

  return (
    <ContentContainer>
      <AboutWrapper>
        <AboutfirstItemWrapper>
          <DiscoweImg src={Images.discoweImg} alt="Discover New Horizons" />

          <DiscoverWrapper>
            <SectionTitle>Discover New Horizons</SectionTitle>

            <ButtonConainer>
              {buttons.map(({ id, name, onclickType, type }) => (
                <Button
                  key={id}
                  section={section}
                  type={type}
                  onClick={() => setSection(onclickType)}
                >
                  {name}
                </Button>
              ))}
            </ButtonConainer>

            <AboutSectionSubTitle>{aboutSectionInfo[section]}</AboutSectionSubTitle>

            <AboutSectionReadMoreButtonContainer>
              {/* todo */}
              {/* <ReadMoreButton onClick={() => navigate(ROUTES.ABOUT_US)}>
                Read More
              </ReadMoreButton>
              <ReadMoreButtonIcon src={Images.readMoreIcon} alt="more" /> */}
            </AboutSectionReadMoreButtonContainer>

            <TravelIcon src={Images.travelcon} alt="Discover New Horizons" />
          </DiscoverWrapper>
        </AboutfirstItemWrapper>

        <SecondSection>
          <SecondSectionInfo>
            <SectionTitle>Magical memories,</SectionTitle>

            <SectionTitle>Bespoke experiences</SectionTitle>

            <AboutSectionSubTitle>
              {about
                ? aboutSectionInfo.magicalMemories
                : aboutSectionInfo.magicalMemories.substring(0, 423)}
            </AboutSectionSubTitle>

            {!about && (
              <AboutSectionReadMoreButtonContainer>
                <ReadMoreButton onClick={() => navigate(ROUTES.ABOUT_US)}>
                  Read More
                  <ReadMoreButtonIcon src={Images.readMoreIcon} alt="more" />
                </ReadMoreButton>
              </AboutSectionReadMoreButtonContainer>
            )}
          </SecondSectionInfo>

          <DiscoverBackSecondImage
            src={Images.discoverBackSecond}
            alt="Discover New Horizons"
          />
        </SecondSection>
      </AboutWrapper>
    </ContentContainer>
  );
};
